import { AxiosInstance } from "axios";

interface ProductDataEndpoints{
    options: string,
    excesses: string,
    limits: string,
    sumsinsured: string,
    validateAddress: string,
    [others: string]: any
}


interface ProductDataConfig{
    axios: AxiosInstance,
    endpoints: ProductDataEndpoints,
    [others: string]: any
}


export default function (config:ProductDataConfig){
    
    const initialState = {
        axios: config.axios,
        endpoints: config.endpoints,
        loading: false,
        loaded: false,
    }    
    
    
    return function(state = initialState, action) {
        switch(action.type){

            //
            case "REQUEST_PRODUCT_DATA":
                return {
                    ...state,
                    loading: true,
                    loaded: false
                }
            
            //
            case "SUPPLY_PRODUCT_DATA":
                return {
                    ...state,
                    ...action.productData,
                    loading: false,
                    loaded: true
                }
                

            default: return state;
        }

    }

}




// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/modules/product-data/product-data-reducer.ts